import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import GenreGrid from "./components/GenreGrid";
import LatestUpdates from "./components/LatestUpdates";
import ComicCard from "@/components/feature/ComicCard";
import { comics, siteIntro } from "@/mocks/comics";

export default function Home() {
  const popular = [...comics].sort((a, b) => b.views - a.views).slice(0, 8);
  const favorites = [...comics].sort((a, b) => b.favorites - a.favorites).slice(0, 5);

  return (
    <div className="w-full">
      <HeroCarousel />

      <GenreGrid />

      <LatestUpdates />

      <section className="w-full px-4 md:px-6 py-12">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 flex items-center gap-2">
              <i className="ri-fire-fill text-primary-500" />
              热门推荐
            </h2>
            <p className="mt-1 text-sm text-foreground-500">按阅读量与收藏量精选的口碑之作</p>
          </div>
          <Link
            to="/category?sort=popular"
            className="text-sm text-primary-500 hover:text-primary-400 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            更多热门
            <i className="ri-arrow-right-s-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="lg:col-span-3 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {popular.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>

          <aside className="lg:col-span-1 rounded-lg bg-background-100 border border-background-200 p-4 h-fit">
            <h3 className="font-heading font-semibold text-foreground-950 mb-4 flex items-center gap-2">
              <i className="ri-bookmark-3-fill text-accent-500" />
              收藏榜
            </h3>
            <ul className="space-y-3">
              {favorites.map((comic, i) => (
                <li key={comic.id}>
                  <Link
                    to={`/detail/${comic.id}`}
                    className="group flex items-center gap-3"
                  >
                    <span
                      className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold shrink-0 ${
                        i < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {i + 1}
                    </span>
                    <div className="w-10 h-[52px] rounded overflow-hidden shrink-0">
                      <img
                        src={comic.cover}
                        alt={`${comic.title} 收藏榜封面`}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                        {comic.title}
                      </p>
                      <p className="text-xs text-foreground-500 flex items-center gap-1">
                        <i className="ri-heart-3-line" />
                        {(comic.favorites / 10000).toFixed(1)}万
                      </p>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-12">
        <div className="rounded-lg bg-secondary-100 border border-background-200 p-6 md:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
            <div className="lg:col-span-2">
              <h1 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">
                {siteIntro.name} 高清漫画在线阅读平台
              </h1>
              <p className="mt-2 text-sm md:text-base text-primary-400">{siteIntro.slogan}</p>
              <p className="mt-5 text-sm text-foreground-700 leading-relaxed max-w-2xl">
                {siteIntro.paragraphs[0]}
              </p>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed max-w-2xl">
                {siteIntro.paragraphs[1]}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Link
                  to="/category"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-stack-line" />
                  浏览全部漫画
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-100 border border-background-300 text-foreground-950 font-medium text-sm hover:border-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-information-line" />
                  了解 JMcomic2
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-3 lg:grid-cols-1 gap-4">
              {[
                { value: "18万+", label: "在线作品" },
                { value: "1200万", label: "注册读者" },
                { value: "每日", label: "更新提醒" },
              ].map((stat) => (
                <div key={stat.label} className="rounded-lg bg-background-100 border border-background-200 p-4 text-center lg:text-left">
                  <p className="font-heading font-bold text-lg md:text-xl text-accent-500">{stat.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}